import { Money } from '@betterment/core';
import { createConfig, createFlowContext } from '@betterment/shared-components';
import { Outlet, useParams } from 'react-router-dom';
import * as Yup from 'yup';

import { nameAndImage } from '../sharedSchemas';

export const majorPurchaseNameAndImage = Yup.object({
  ...nameAndImage.fields,
  purpose_sub_type: Yup.string().required('Please choose a sepecific goal type.'),
});

export const target = Yup.object({
  amount: Yup.mixed<Money>().optional(),
  month: Yup.string()
    .required()
    .test('target-date-in-future', "Target date must be after today's date.", function checkDate(month) {
      const { year } = this.parent as { year: string };
      const today = new Date();
      const targetDate = new Date(`${month}, ${year}`);
      return targetDate > today;
    }),
  year: Yup.string().required(),
});

export const MAJOR_PURCHASE_FLOW_CONFIG = createConfig({
  nameAndImage: {
    schema: majorPurchaseNameAndImage,
    dependencies: Yup.object({}),
  },
  target: {
    schema: target,
    dependencies: Yup.object({
      nameAndImage: majorPurchaseNameAndImage,
    }),
  },
});

export const { FlowProvider, useStep: useMajorPurchaseStep } = createFlowContext(MAJOR_PURCHASE_FLOW_CONFIG);

export const MajorPurchaseFlow = () => {
  const { flowId } = useParams<{ flowId: string }>();

  return (
    <FlowProvider flowId={flowId}>
      <Outlet />
    </FlowProvider>
  );
};
